<!-- <div class="main-stepper">
    <div class="menu-back pt-3">
        <button mat-raised-button (click)="onClickOfGenericCancelButton($event)">
            <mat-icon class="me-1">keyboard_backspace</mat-icon>Back
        </button>
    </div>
    <mat-stepper orientation="horizontal" [linear]="isLinear" #stepper>
        <mat-step>
            <ng-template matStepLabel>Business Partner</ng-template>
            <div class="">
                <div class="page-content">
                    <h2 class="heading1 mb-5"> {{this.getObjectType==enumObjType.Customer ?'Customer':
                        this.getObjectType==enumObjType.Vendor ? 'Vendor' : 'CRM'}}</h2>

                    <h3 class="heading2">{{getFormTitle}}</h3>
                    <div class="row entry-forms w-55">
                        <div class="row">
                            <div class="col-md-6">
                                <label class="f-label">{{this.getObjectType==enumObjType.Customer ?'Customer Name':
                                    this.getObjectType==enumObjType.Vendor ? 'Vendor Name' : 'Lead Name'}}</label>
                                <mat-form-field class="full-width" appearance="outline">
                                    <input type="text" matInput name="cardName"
                                        [(ngModel)]="this.getEntryFormDataSource.cardName"
                                        (ngModelChange)="btnEvent($event)">
                                </mat-form-field>
                            </div>
                            <div class="col-md-6">
                                <label class="f-label">{{this.getObjectType==enumObjType.Customer ?'Customer Code':
                                    this.getObjectType==enumObjType.Vendor ? 'Vendor Code' : 'Lead Code'}}</label>
                                <mat-form-field class="full-width" appearance="outline">
                                    <input type="text" matInput name="cardCode"  [disabled]="this.getFormDisable"
                                        [(ngModel)]="this.getEntryFormDataSource.cardCode"
                                        (ngModelChange)="btnEvent($event)">
                                </mat-form-field>
                            </div>
                 

                            <div class="col-md-6">
                                <label class="f-label"> {{'Language.GroupText' | translate }}</label>
                                <mat-form-field class="full-width" appearance="outline"
                                    (click)="onOpenDropDown('group')">
                                    <input type="text" matInput name="group"
                                        [(ngModel)]="this.getEntryFormDataSource.groupName" readonly>
                                    <img src="./assets/images/cfl.svg" matSuffix alt="" class="me-2">
                                </mat-form-field>
                            </div>
                            <div class="col-md-6">
                                <label class="f-label">{{'Language.CurrencyText' | translate }}</label>
                                <mat-form-field class="full-width" appearance="outline"
                                    (click)="onOpenDropDown('currency')">
                                    <input type="text" matInput name="currency"
                                        [(ngModel)]="this.getEntryFormDataSource.currencyName" readonly>
                                    <img src="./assets/images/cfl.svg" matSuffix alt="" class="me-2">
                                </mat-form-field>
                            </div>
                            <div class="col-md-6" *ngIf="this.isBpType=='customer'|| this.isBpType=='vendor'">
                                <label class="f-label">{{'Language.AccountBalanceText' | translate }}</label>
                                <mat-form-field class="full-width" appearance="outline">
                                    <input type="text" matInput name="accountBalance" disabled
                                        [(ngModel)]="this.getEntryFormDataSource.currentAccountBalance">
                                </mat-form-field>
                            </div>
                            <div class="col-md-6" *ngIf="this.isBpType=='customer'">
                                <label class="f-label">{{'Language.OpenDeliveriesText' | translate }}</label>
                                <mat-form-field class="full-width" appearance="outline">
                                    <input type="text" matInput name="openDeliveries" disabled
                                        [(ngModel)]="this.getEntryFormDataSource.openDeliveryNotesBalance">
                                </mat-form-field>
                            </div>
                            <div class="col-md-6" *ngIf="this.isBpType=='lead'|| this.isBpType=='customer'">
                                <label class="f-label">{{'Language.OpenOrderBalanceText' | translate }}</label>
                                <mat-form-field class="full-width" appearance="outline">
                                    <input type="text" matInput name="openOrderBalance" disabled
                                        [(ngModel)]="this.getEntryFormDataSource.openOrdersBalance">
                                </mat-form-field>
                            </div>
                            <div class="col-md-6" *ngIf="this.isBpType=='lead'||this.isBpType=='customer'">
                                <label class="f-label">{{'Language.OpenOpportunityText' | translate }}</label>
                                <mat-form-field class="full-width" appearance="outline">
                                    <input type="text" matInput name="OpenOpportunity" disabled
                                        [(ngModel)]="this.getEntryFormDataSource.openOrdersBalance">
                                </mat-form-field>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="mt-2 footer">
                    <div class="d-flex">
                        <div class="me-auto">
                            <button mat-stroked-button color="primary"
                                (click)="onClickOfGenericCancelButton($event)">Cancel</button>
                        </div>
                        <div class="">
                            <button mat-raised-button color="primary" class="ms-2" matStepperNext>
                                Next<i-feather class="t-icon" name="chevron-right"> </i-feather>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </mat-step>

   

        <mat-step>
            <ng-template matStepLabel>General</ng-template>
            <div class="">
                <div class="page-content">
                    <h2 class="heading1 mb-4">Business Partner</h2>
                    <h2 class="heading2">{{'Language.GeneralText' | translate }}</h2>
                    <div class="row entry-forms ">
                        <div class="col-md-4">
                            <label class="f-label">{{'Language.E-MailText' | translate }}</label>
                            <mat-form-field class="full-width" appearance="outline">
                                <input type="text" matInput name="email"
                                    [(ngModel)]="this.getEntryFormDataSource.e_Mail" (ngModelChange)="btnEvent($event)">
                            </mat-form-field>
                        </div>
                        <div class="col-md-4">
                            <label class="f-label">{{'Language.BusinessPartnerTypeText' | translate }}</label>
                            <mat-form-field class="full-width" appearance="outline" (click)="onOpenDropDown('bptype')">
                                <input type="text" matInput name="bptype"
                                    [(ngModel)]="this.getEntryFormDataSource.businessTypeName" readonly>
                                <img src="./assets/images/cfl.svg" matSuffix alt="" class="me-2">
                            </mat-form-field>
                        </div>
                        <div class="col-md-4">
                            <label class="f-label">{{'Language.ContactPersonText' | translate }}</label>
                            <mat-form-field class="full-width" appearance="outline">
                                <input type="text" matInput name="contactPerson"
                                    [(ngModel)]="this.getEntryFormDataSource.contactPerson"
                                    (ngModelChange)="btnEvent($event)">
                            </mat-form-field>
                        </div>
                        <div class="col-md-4">
                            <mat-radio-button value="active" [checked]="this.getEntryFormDataSource.valid=='Y'"
                                (change)="onChangeRadio($event)" (ngModelChange)="btnEvent($event)">
                                {{'Language.ActiveText' | translate }}</mat-radio-button>
                            <mat-radio-button value="inactive" [checked]="this.getEntryFormDataSource.frozen=='Y'"
                                (change)="onChangeRadio($event)" (ngModelChange)="btnEvent($event)">
                                {{'Language.InactiveText' | translate }}</mat-radio-button>
                        </div>
                    </div>
                </div>
                <div class="mt-2 footer">
                    <div class="d-flex">
                        <div class="me-auto">
                            <button mat-stroked-button color="primary"
                                (click)="onClickOfGenericCancelButton($event)">Cancel</button>
                        </div>
                        <div class="">
                            <button mat-raised-button color="primary" matStepperPrevious>
                                <i-feather class="t-icon" name="chevron-left"> </i-feather>
                                Previous
                            </button>
                            <button mat-raised-button color="primary" class="ms-2" matStepperNext>
                                Next<i-feather class="t-icon" name="chevron-right"> </i-feather>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </mat-step>




        <mat-step>
            <ng-template matStepLabel> Contact Person </ng-template>
            <div class="">
                <div class="page-content">
                    <h2 class="heading1 mb-4">Business Partner</h2>
                    <h2 class="heading2">{{'Language.ContactPersonText' | translate }} </h2>
                    <div class="row entry-forms">
                        <div class="col-md-7" style="margin-top: 10px;">
                            <div class="">
                                <div class="row">
                                    <div style="cursor: pointer;" class="col-md-12">
                                        <div class="row">
                                            <div class="col-md-6">
                                                <div class="tabledesign contactEmployeestable">
                                                    <table mat-table class="mat-elevation-z8" [dataSource]="this.getEntryFormDataSource.contactEmployees">
                                                        <ng-container matColumnDef="contactPersonTitle">
                                                            <th mat-header-cell *matHeaderCellDef>
                                                                {{'Language.ContactPersonTitleText' | translate }}
                                                            </th>
                                                            <td mat-cell *matCellDef="let element let i=index"
                                                                class="app-vf-td-mat-cell">
                                                                <div class="pt-1">
                                                                    <mat-form-field class="field-bottom-0" appearance="outline">
                                                                        <input matInput [(ngModel)]="element.name"
                                                                            name="name"
                                                                            (click)="onEditContactPerson(element,i)"
                                                                            value="{{element?.name?.toUpperCase()}}"
                                                                            readonly>
                                                                    </mat-form-field>
                                                                </div>
                                                            </td>
                                                        </ng-container>
                                                        <ng-container matColumnDef="delete">
                                                            <th mat-header-cell *matHeaderCellDef>{{'Language.DeleteText' | translate}}</th>
                                                            <td mat-cell *matCellDef="let element;let i=index">
                                                              <i-feather class="t-icon pointer" name="trash-2" (click)="deleteContactPersonRow(i)"></i-feather>
                                                            </td>
                                                        </ng-container>

                                                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                                        <tr mat-row *matRowDef="let row; columns: displayedColumns;">
                                                        </tr>
                                                    </table>
                                                </div>
                                                <div class="col-md-12 mt-3">
                                                    <button #buttonAddContact mat-raised-button color="primary"
                                                        (click)="onAddNewContactPerson()">
                                                        {{'Language.AddNewContactPersonText' | translate }}
                                                    </button>

                                                    
                                                </div>
                                                
                                         
    
                                            </div>
                                         
                                        </div>
                                    </div>
                                </div>
                             
                            </div>
                        </div>
                        <div class="col-md-5" style="margin-top: -4px;margin-bottom: -4px;"
                            *ngIf="(this.getEntryFormDataSource.contactEmployees != null && this.getEntryFormDataSource.contactEmployees.length>0)">
                            <div class="col-md-12">
                                <label class="f-label">{{'Language.ContactIdText' | translate }}</label>
                                <mat-form-field class="full-width" appearance="outline">
                                    <input type="text" #title matInput name="name"
                                        [(ngModel)]="this.getEntryFormDataSource.contactEmployees[this.indexCP].name"
                                        (ngModelChange)="btnEvent($event)">
                                </mat-form-field>
                            </div>
                            <div class="col-md-12">
                                <label class="f-label">{{'Language.TitleText' | translate }}</label>
                                <mat-form-field class="full-width" appearance="outline">
                                    <input type="text" #title matInput name="title"
                                        [(ngModel)]="this.getEntryFormDataSource.contactEmployees[this.indexCP].title"
                                        (ngModelChange)="btnEvent($event)">
                                </mat-form-field>
                            </div>
                            <div class="col-md-12">
                                <label class="f-label">{{'Language.FirstNameText' | translate }}</label>
                                <mat-form-field class="full-width" appearance="outline">
                                    <input type="text" matInput name="firstName"
                                        [(ngModel)]="this.getEntryFormDataSource.contactEmployees[this.indexCP].firstName"
                                        (ngModelChange)="btnEvent($event)">
                                </mat-form-field>
                            </div>
                            <div class="col-md-12">
                                <label class="f-label">{{'Language.LastNameText' | translate }}</label>
                                <mat-form-field class="full-width" appearance="outline">
                                    <input type="text" matInput name="lastName"
                                        [(ngModel)]="this.getEntryFormDataSource.contactEmployees[this.indexCP].lastName"
                                        (ngModelChange)="btnEvent($event)">
                                </mat-form-field>
                            </div>
                            <div class="col-md-12">
                                <label class="f-label">{{'Language.E-MailText' | translate }}</label>
                                <mat-form-field class="full-width" appearance="outline">
                                    <input type="text" matInput name="email"
                                        [(ngModel)]="this.getEntryFormDataSource.contactEmployees[this.indexCP].e_Mail"
                                        (ngModelChange)="btnEvent($event)">
                                </mat-form-field>
                            </div>
                            <div class="col-md-12">
                                <label class="f-label">{{'Language.Telephone1Text' | translate }}</label>
                                <mat-form-field class="full-width" appearance="outline">
                                    <input type="text" matInput name="telephone1"
                                        [(ngModel)]="this.getEntryFormDataSource.contactEmployees[this.indexCP].phone1"
                                        (ngModelChange)="btnEvent($event)">
                                </mat-form-field>
                            </div>
                            <div class="col-md-12">
                                <label class="f-label">{{'Language.MobilePhoneText' | translate }}</label>
                                <mat-form-field class="full-width" appearance="outline">
                                    <input type="text" [textMask]="{mask: phoneMaskCharacters}" matInput
                                        name="mobilephone"
                                        [(ngModel)]="this.getEntryFormDataSource.contactEmployees[this.indexCP].mobilePhone"
                                        (ngModelChange)="btnEvent($event)">
                                </mat-form-field>
                            </div>
                            <div class="col-md-12">
                                <label class="f-label">{{'Language.PositionText' | translate }}</label>
                                <mat-form-field class="full-width" appearance="outline">
                                    <input type="text" matInput name="position"
                                        [(ngModel)]="this.getEntryFormDataSource.contactEmployees[this.indexCP].position"
                                        (ngModelChange)="btnEvent($event)">
                                </mat-form-field>
                            </div>
                            <div class="col-md-4">
                                <mat-checkbox value="element.active"
                                    [checked]="this.getEntryFormDataSource.contactEmployees[this.indexCP].active=='Y'"
                                    (change)="onChangeContactActiveCheckBox($event)" (ngModelChange)="btnEvent($event)">
                                    Active
                                </mat-checkbox>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="mt-2 footer">
                    <div class="d-flex">
                        <div class="me-auto">
                            <button mat-stroked-button color="primary"
                                (click)="onClickOfGenericCancelButton($event)">Cancel</button>
                        </div>
                        <div class="">
                            <button mat-raised-button color="primary" matStepperPrevious>
                                <i-feather class="t-icon" name="chevron-left"> </i-feather>
                                Previous
                            </button>
                            <button mat-raised-button color="primary" class="ms-2" matStepperNext>
                                Next<i-feather class="t-icon" name="chevron-right"> </i-feather>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </mat-step>

        <mat-step>
            <ng-template matStepLabel>Address </ng-template>
            <div class="">
                <div class="page-content">
                    <h2 class="heading1 mb-4">Business Partner</h2>
                    <h2 class="heading2">Address</h2>
                    <div class="row entry-forms">
                        <div class="col-md-7" style="margin-top: 10px;">
                            <div class="">
                                <div class="row">
                                    <mat-label class="f-label">{{'Language.BillToText' | translate }}</mat-label>
                                    <div style=" width: 300px; height: 100px; overflow-y: scroll;">
                                        <div style="cursor: pointer;" class="col-md-12"
                                            *ngFor="let item of this.getEntryFormDataSource.bpAddresses;index as i">
                                            <div class="row" *ngIf="item.addressType=='bo_BillTo'">
                                                <div class="col-md-6">
                                                    <mat-form-field class="field-bottom-0" appearance="outline">
                                                        <input type="text" matInput (click)="onEditAddress(item,i)"
                                                            readonly value="{{item?.addressName}}"
                                                            (ngModelChange)="btnEvent($event)">
                                                    </mat-form-field>`
                                                </div>
                                                <div class="col-md-6">
                                                 
                                                  
                                                        <button mat-mini-fab color="primary"  (click)="deleteAddressRow(i)">
                                                            <mat-icon>deleteBillto</mat-icon>
                                                          </button>
                                                         
                                                
                                                      
                                                </div>
                                            </div>
                                           
    
                                        </div>
                                    </div>
                                    <div class="col-md-12" style="margin-top: 4px;">
                                        <div class="">
                                            <button #buttonAddAddress mat-raised-button color="primary"
                                                (click)="onAddNewAddress('bo_BillTo')">
                                                {{'Language.AddNewBillToAddressText' | translate }}
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <mat-label class="f-label">{{'Language.ShipToText' | translate }}</mat-label>
                                    <div style=" width: 300px; height: 100px; overflow-y: scroll;">
                                        <div style="cursor: pointer;" class="col-md-12"
                                            *ngFor="let item of this.getEntryFormDataSource.bpAddresses;index as i">
                                            <div class="row" *ngIf="item.addressType=='bo_ShipTo'">
                                                <div class="col-md-6">
                                                    <mat-form-field class="field-bottom-0" appearance="outline">
                                                        <input type="text" matInput (click)="onEditAddress(item,i)"
                                                            readonly value="{{item?.addressName}}">
                                                    </mat-form-field>

                                                </div>
                                                <div class="col-md-6">
                                                  
                                                
                                                    <button mat-mini-fab color="primary"  (click)="deleteAddressRow(i)">
                                                        <mat-icon>deleteShipto</mat-icon>
                                                      </button>
                                                     
                                              
                                             
                                            </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-12" style="margin-top: 4px;">
                                        <div class="">
                                            <button #buttonSave mat-raised-button color="primary"
                                                (click)="onAddNewAddress('bo_ShipTo')">
                                                {{'Language.AddNewShipToAddressText' | translate }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-5" style="margin-top: -4px;margin-bottom: -4px;"
                            *ngIf="this.getEntryFormDataSource.bpAddresses != null && this.getEntryFormDataSource.bpAddresses.length>0">
                            <div class="col-md-12">
                                <mat-checkbox
                                    value="this.getEntryFormDataSource.bpAddresses[this.indexAddress].isBoolCopyToShipToAddressChecked"
                                    [checked]="this.getEntryFormDataSource.bpAddresses[this.indexAddress].isBoolCopyToShipToAddressChecked"
                                    (change)="onChangeCopyCheckBox($event)" (ngModelChange)="btnEvent($event)">
                                    {{'Language.CopyToShipToAddressText' | translate }}
                                </mat-checkbox>
                            </div>
                            <div class="col-md-12">
                                <label class="f-label">{{'Language.AddressTypeText' | translate }}</label>
                                <mat-form-field class="full-width" appearance="outline">
                                    <input type="text" #title matInput name="title"
                                        [(ngModel)]="this.getEntryFormDataSource.bpAddresses[this.indexAddress].addressType"
                                        readonly="true">
                                </mat-form-field>
                            </div>
                            <div class="col-md-12">
                                <label class="f-label">{{'Language.AddressNameText' | translate }}</label>
                                <mat-form-field class="full-width" appearance="outline">
                                    <input type="text" #title matInput name="title"
                                        [(ngModel)]="this.getEntryFormDataSource.bpAddresses[this.indexAddress].addressName"
                                        (ngModelChange)="btnEvent($event)">
                                </mat-form-field>
                            </div>
                            <div class="col-md-12">
                                <label class="f-label">{{'Language.CountryText' | translate }}</label>
                                <mat-form-field class="full-width" appearance="outline"
                                    (click)="onOpenDropDown('country')">
                                    <input type="text" matInput name="country" readonly
                                        [(ngModel)]="this.getEntryFormDataSource.bpAddresses[this.indexAddress].countryName">
                                    <img src="./assets/images/cfl.svg" matSuffix alt="" class="me-2">
                                </mat-form-field>
                            </div>
                            <div class="col-md-12">
                                <label class="f-label">{{'Language.Street/PoBoxNo.Text' | translate }}</label>
                                <mat-form-field class="full-width" appearance="outline">
                                    <input type="text" matInput name="street"
                                        [(ngModel)]="this.getEntryFormDataSource.bpAddresses[this.indexAddress].street"
                                        (ngModelChange)="btnEvent($event)">
                                </mat-form-field>
                            </div>
                            <div class="col-md-12">
                                <label class="f-label">{{'Language.StreeNo.Text' | translate }}</label>
                                <mat-form-field class="full-width" appearance="outline">
                                    <input type="text" matInput name="streetno"
                                        [(ngModel)]="this.getEntryFormDataSource.bpAddresses[this.indexAddress].streetNo"
                                        (ngModelChange)="btnEvent($event)">
                                </mat-form-field>
                            </div>
                            <div class="col-md-12">
                                <label class="f-label">{{'Language.CityText' | translate }}</label>
                                <mat-form-field class="full-width" appearance="outline">
                                    <input type="text" matInput name="city"
                                        [(ngModel)]="this.getEntryFormDataSource.bpAddresses[this.indexAddress].city"
                                        (ngModelChange)="btnEvent($event)">
                                </mat-form-field>
                            </div>
                            <div class="col-md-12">
                                <label class="f-label">{{'Language.StateText' | translate }}</label>
                                <mat-form-field class="full-width" appearance="outline"
                                    (click)="onOpenDropDown('state')">
                                    <input type="text" matInput name="state" readonly
                                        [(ngModel)]="this.getEntryFormDataSource.bpAddresses[this.indexAddress].stateName">
                                    <img src="./assets/images/cfl.svg" matSuffix alt="" class="me-2">
                                </mat-form-field>
                            </div>

                            <div class="col-md-12">
                                <label class="f-label">{{'Language.ZipCodeText' | translate }}</label>
                                <mat-form-field class="full-width" appearance="outline">
                                    <input type="text" matInput name="zipCode"
                                        [(ngModel)]="this.getEntryFormDataSource.bpAddresses[this.indexAddress].zipCode"
                                        (ngModelChange)="btnEvent($event)">
                                </mat-form-field>
                            </div>
                            <div class="col-md-12">
                                <label class="f-label">{{'Language.GSTTypeText' | translate }}</label>
                                <mat-form-field class="full-width" appearance="outline"
                                    (click)="onOpenDropDown('gsttype')">
                                    <input type="text" matInput name="gsttype" readonly
                                        [(ngModel)]="this.getEntryFormDataSource.bpAddresses[this.indexAddress].gstTypeName">
                                    <img src="./assets/images/cfl.svg" matSuffix alt="" class="me-2">
                                </mat-form-field>
                            </div>
                            <div class="col-md-12">
                                <label class="f-label">{{'Language.GSTINText' | translate }}</label>
                                <mat-form-field class="full-width" appearance="outline">
                                    <input type="text" matInput name="gstin"
                                        [(ngModel)]="this.getEntryFormDataSource.bpAddresses[this.indexAddress].gstin"
                                        (ngModelChange)="btnEvent($event)">
                                </mat-form-field>
                            </div>
                            <div class="col-md-12">
                                <mat-checkbox
                                    value="this.getEntryFormDataSource.bpAddresses[this.indexAddress].isAsDefault"
                                    [checked]="this.getEntryFormDataSource.bpAddresses[this.indexAddress].isAsDefault"
                                    (change)="onChangeSetAsDefaultCheckBox($event)" (ngModelChange)="btnEvent($event)">
                                    {{'Language.SetAsDefaultText' | translate }}
                                </mat-checkbox>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="mt-2 footer">
                    <div class="d-flex">
                        <div class="me-auto">
                            <button mat-stroked-button color="primary"
                                (click)="onClickOfGenericCancelButton($event)">Cancel</button>
                        </div>
                        <div class="">
                            <button mat-raised-button color="primary" matStepperPrevious>
                                <i-feather class="t-icon" name="chevron-left"> </i-feather>
                                Previous
                            </button>
                            <button mat-raised-button color="primary" class="ms-2" matStepperNext>
                                Next<i-feather class="t-icon" name="chevron-right"> </i-feather>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </mat-step>



        <mat-step>

            <ng-template matStepLabel>
                Payment Terms
            </ng-template>
            <div class="">
                <div class="page-content">
                    <h2 class="heading1 mb-4">Business Partner</h2>
                    <h2 class="heading2">{{'Language.PaymentTermsText' | translate }}</h2>
                    <div class="row entry-forms">
                        <div class="col-md-4" style="margin-top: 10px;">
                            <div class="">
                                <div class="row">
                                    <div style="cursor: pointer;" class="col-md-12">
                                        <div class="row">
                                           
                                            <div class="col-md-9">
                                                <div class="tabledesign">
                                                    <table mat-table class="mat-elevation-z8"
                                                        [dataSource]="this.getEntryFormDataSource.bpBankAccounts">
                                                        <ng-container matColumnDef="bankName">
                                                            <th mat-header-cell *matHeaderCellDef>
                                                                {{'Language.BankNameText' | translate }}
                                                            </th>
                                                            <td mat-cell *matCellDef="let element let i=index"
                                                                class="app-vf-td-mat-cell">
                                                                <div class="pt-1">
                                                                    <mat-form-field class="field-bottom-0"
                                                                        appearance="outline">
                                                                        <input matInput [(ngModel)]="element.bankName"
                                                                            name="bankName"
                                                                            (click)="onEditBank(element,i)"
                                                                            value="{{element?.bankName?.toUpperCase()}}"
                                                                            readonly>
                                                                    </mat-form-field>
                                                                </div>
                                                            </td>
                                                        </ng-container>

                                                        <tr mat-header-row
                                                            *matHeaderRowDef="displayedColumnPaymentTerms"></tr>
                                                        <tr mat-row
                                                            *matRowDef="let row; columns: displayedColumnPaymentTerms;">
                                                        </tr>
                                                    </table>
                                                </div>
                                                <div class="col-md-12 mt-3">
                                                    <button #buttonAddContact mat-raised-button color="primary"
                                                        (click)="onAddNewBank()">
                                                        {{'Language.AddNewBankText' | translate }}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4" style="margin-top: 4px;">
                            <div class="col-md-8">
                                <label class="f-label">{{'Language.PaymentTermsText' | translate }}</label>
                                <mat-form-field class="full-width" appearance="outline"
                                    (click)="onOpenDropDown('paymentterms')">
                                    <input type="text" matInput name="paymentterms" readonly
                                        [(ngModel)]="this.getEntryFormDataSource.payTermsGrpCodeName">
                                    <img src="./assets/images/cfl.svg" matSuffix alt="" class="me-2">
                                </mat-form-field>
                            </div>
                            <div class="col-md-8">
                                <label class="f-label">{{'Language.PriceListText' | translate }}</label>
                                <mat-form-field class="full-width" appearance="outline"
                                    (click)="onOpenDropDown('pricelist')">
                                    <input type="text" matInput name="pricelist" readonly
                                        [(ngModel)]="this.getEntryFormDataSource.priceListName">
                                    <img src="./assets/images/cfl.svg" matSuffix alt="" class="me-2">
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="col-md-4" style="margin-top: -4px;margin-bottom: -4px;"
                            *ngIf="this.getEntryFormDataSource.bpBankAccounts != null&& this.getEntryFormDataSource.bpBankAccounts.length>0">
                            <div class="col-md-12">
                                <label class="f-label">{{'Language.BankAccountNameText' | translate }}</label>
                                <mat-form-field class="full-width" appearance="outline">
                                    <input type="text" #title matInput name="accountname"
                                        [(ngModel)]="this.getEntryFormDataSource.bpBankAccounts[this.indexBank].accountName"
                                        (ngModelChange)="btnEvent($event)">
                                </mat-form-field>
                            </div>
                            <div class="col-md-12">
                                <label class="f-label">{{'Language.BankNameText' | translate }}</label>
                                <mat-form-field class="full-width" appearance="outline"
                                    (click)="onOpenDropDown('bank')">
                                    <input type="text" matInput name="bankname" readonly
                                        [(ngModel)]="this.getEntryFormDataSource.bpBankAccounts[this.indexBank].bankName">
                                    <img src="./assets/images/cfl.svg" matSuffix alt="" class="me-2">
                                </mat-form-field>
                            </div>
                            <div class="col-md-12">
                                <label class="f-label">{{'Language.AccountNo.Text' | translate }}</label>
                                <mat-form-field class="full-width" appearance="outline">
                                    <input type="text" matInput name="street"
                                        [(ngModel)]="this.getEntryFormDataSource.bpBankAccounts[this.indexBank].accountNo"
                                        (ngModelChange)="btnEvent($event)">
                                </mat-form-field>
                            </div>
                            <div class="col-md-12">
                                <label class="f-label">{{'Language.IFSCCodeText' | translate }}</label>
                                <mat-form-field class="full-width" appearance="outline">
                                    <input type="text" matInput name="bicSwiftcode"
                                        [(ngModel)]="this.getEntryFormDataSource.bpBankAccounts[this.indexBank].bicSwiftCode"
                                        (ngModelChange)="btnEvent($event)">
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="mt-2 footer">
                    <div class="d-flex">
                        <div class="me-auto">
                            <button mat-stroked-button color="primary"
                                (click)="onClickOfGenericCancelButton($event)">Cancel</button>
                        </div>
                        <div class="">
                            <button mat-raised-button color="primary" matStepperPrevious>
                                <i-feather class="t-icon" name="chevron-left"> </i-feather>
                                Previous
                            </button>
                            <button mat-raised-button color="primary" class="ms-2" matStepperNext>
                                Next<i-feather class="t-icon" name="chevron-right"> </i-feather>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </mat-step>




        <mat-step>
            <ng-template matStepLabel> Accounting </ng-template>
            <div class="">
                <div class="page-content">
                    <h2 class="heading1 mb-4">Business Partner</h2>
                    <h2 class="heading2">{{'Language.AccountingText' | translate }}</h2>
                    <div class="row entry-forms">
                        <div class="col-md-7" style="margin-top: 10px;">
                        </div>
                        <div class="col-md-5" style="margin-top: -4px;margin-bottom: -4px;">
                            <div class="col-md-12">
                                <label class="f-label">{{getObjectType==enumObjType.Customer ?'Connected Vendor':'Connected Customer'}} </label>
                                <mat-form-field class="full-width" appearance="outline"
                                    (click)="onOpenDropDown('connectedvendor')">
                                    <input type="text" matInput name="connectedvendor" readonly
                                        [(ngModel)]="this.getEntryFormDataSource.linkedBusinessPartnerName">
                                    <img src="./assets/images/cfl.svg" matSuffix alt="" class="me-2">
                                </mat-form-field>
                            </div>
                            <div class="col-md-12">
                                <mat-checkbox value="this.getEntryFormDataSource.subjectToWithholdingTax"
                                    [checked]="this.getEntryFormDataSource.subjectToWithholdingTax=='Y'"
                                    (change)="onChangeSubjectToWithholdingTax($event)"
                                    (ngModelChange)="btnEvent($event)">
                                    {{'Language.SubjecttoWithholdingTaxText' | translate }}
                                </mat-checkbox>
                            </div>
                            <div *ngIf="this.getEntryFormDataSource.subjectToWithholdingTax=='Y'">
                                <div class="col-md-12">
                                    <label class="f-label">{{'Language.AsseseeTypeText' | translate }}</label>
                                    <mat-form-field class="full-width" appearance="outline"
                                        (click)="onOpenDropDown('assesseetype')">
                                        <input type="text" matInput name="assesseetype" readonly
                                            [(ngModel)]="this.getEntryFormDataSource.typeReportName">
                                        <img src="./assets/images/cfl.svg" matSuffix alt="" class="me-2">
                                    </mat-form-field>
                                </div>
                                <div class="col-md-12">
                                    <label class="f-label">{{'Language.WTaxCodeAllowedText' | translate }}</label>
                                    <mat-form-field class="full-width" appearance="outline"
                                        (click)="onOpenDropDown('wtaxcode')">
                                        <input type="text" matInput name="watxcodeallowed" readonly
                                            [(ngModel)]="this.getEntryFormDataSource.wtCodeName">
                                        <img src="./assets/images/cfl.svg" matSuffix alt="" class="me-2">
                                    </mat-form-field>
                                </div>
                                <div class="col-md-12"
                                    *ngIf="this.getEntryFormDataSource.bpFiscalTaxIDCollection!=null && this.getEntryFormDataSource.bpFiscalTaxIDCollection.length>0">
                                    <label class="f-label">{{'Language.PANNo.Text' | translate }}</label>
                                    <mat-form-field class="full-width" appearance="outline">
                                        <input type="text" matInput name="panno"
                                            [(ngModel)]="this.getEntryFormDataSource.bpFiscalTaxIDCollection[0].taxId0"
                                            (ngModelChange)="btnEvent($event)">
                                    </mat-form-field>
                                </div>
                                <div class="col-md-12">
                                    <mat-radio-group [(ngModel)]="this.getEntryFormDataSource.accrualCriteria"
                                        name="radioButtons" (change)="onChangeAccontingRadio($event)"
                                        (ngModelChange)="btnEvent($event)">
                                        <mat-radio-button id="accrual" value="Y">{{'Language.AccrualText' | translate }}
                                        </mat-radio-button>
                                        <mat-radio-button id="cash" value="N">{{'Language.CashText' | translate }}
                                        </mat-radio-button>
                                    </mat-radio-group>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div class="mt-2 footer">
                    <div class="d-flex">
                        <div class="me-auto">
                            <button mat-stroked-button color="primary"
                                (click)="onClickOfGenericCancelButton($event)">Cancel</button>
                        </div>

                        <div class="">
                            <button mat-raised-button color="primary" matStepperPrevious>
                                <i-feather class="t-icon" name="chevron-left"> </i-feather>
                                Previous
                            </button>
                            <button mat-raised-button color="primary" class="ms-2" matStepperNext>
                                Next<i-feather class="t-icon" name="chevron-right"> </i-feather>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </mat-step>




        <mat-step>
            <ng-template matStepLabel> Remarks </ng-template>
            <div class="">
                <div class="page-content">
                    <h2 class="heading1 mb-4">Business Partner</h2>
                    <h2 class="heading2">{{'Language.RemarksText' | translate }}</h2>
                    <div class="col-md-4">
                        <label class="f-label">REMARKS</label>
                        <mat-form-field class="full-width" appearance="outline">
                            <textarea matInput [(ngModel)]="this.getEntryFormDataSource.freeText"
                                (ngModelChange)="btnEvent($event)" class="app-ef-textarea"></textarea>
                        </mat-form-field>
                    </div>
                </div>
                <div class="mt-2 footer">
                    <div class="d-flex">
                        <div class="me-auto">
                            <button mat-stroked-button color="primary"
                                (click)="onClickOfGenericCancelButton($event)">Cancel</button>
                        </div>
                        <div class="">
                            <button mat-raised-button color="primary" matStepperPrevious>
                                <i-feather class="t-icon" name="chevron-left"> </i-feather>
                                Previous
                            </button>
                            <button mat-raised-button color="primary" class="ms-2" matStepperNext>
                                Next<i-feather class="t-icon" name="chevron-right"> </i-feather>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </mat-step>


        <mat-step>
            <ng-template matStepLabel> Attachments </ng-template>
            <div class="">
                <div class="page-content">
                    <h2 class="heading1 mb-4">Business Partner</h2>
                    <h2 class="heading2">{{'Language.AttachmentsText' | translate }}</h2>
                    <div class="col-md-12 mt-3">
                        <label class="f-label full-width">{{'Language.AttachmentsText' | translate
                          }}</label>
                        <button mat-raised-button class="uploadbtn" color="primary" (click)="onUpload()">
                          <i-feather class="t-icon" name="upload"> </i-feather>
                          {{'Language.UploadFilesText' | translate }}
                        </button>
                        <input type="file" class="file-upload" (change)="onSelectedFiles($event)" multiple>
                        <span class="field-hint d-block">{{'Language.Youcanuploadamaximumof10files,5MBeachText'
                          | translate }}</span>
                      </div>
                      <div class="col-md-12 mt-4">
                        <div class="carddesign">
                          <div class="row px-3">
                            <label class="col-md-2 f-label">{{'Language.ThumbnailText' | translate
                              }}</label>
                            <label class="col-md-6 f-label">{{'Language.FileNameText' | translate
                              }}</label>
                            <label class="col-md-2 f-label">{{'Language.FileSizeText' | translate
                              }}</label>
                            <label class="col-md-2 f-label"></label>
                          </div>
                          <mat-card class="add-detail-files mb-2" *ngFor="let item;let i = index">
                            <mat-card-content class="py-2">
                              <div class="row">
                                <div class="col-md-2">
                                  <i-feather class="" name="image"></i-feather>
                                </div>
                                <div class="col-md-6">{{item.name}}</div>
                                <div class="col-md-2">{{item.size}}</div>
                                <div class="col-md-2">
                                  <i-feather class="t-icon pointer" name="trash-2"></i-feather>
                                </div>
                              </div>
                            </mat-card-content>
                          </mat-card>
                        </div>
                      </div>
                </div>
            </div>

            <div class="mt-2 footer">
                <div class="d-flex">
                    <div class="me-auto">
                        <button #buttonSave mat-raised-button color="primary" (click)="onSave($event)">
                            {{ btnText | translate}}
                        </button>
                        <button class="me-2" #buttonCancel mat-raised-button
                            (click)="onClickOfGenericCancelButton($event)">
                            {{'Language.CancelText' | translate }}
                        </button>
                    </div>
                    <div class="">
                        <button mat-raised-button color="primary" matStepperPrevious>
                            <i-feather class="t-icon" name="chevron-left"> </i-feather>
                            {{'Language.PreviousText' | translate}}
                        </button>
                    </div>
                </div>
            </div>
        </mat-step>



    </mat-stepper>
</div> -->



<div class="">
    <fieldset [disabled]="(getFormMode == 0 && !canAdd) || (getFormMode == 1 && !canEdit)" class="view-mode-fieldset" style="border: none; padding: 0; margin: 0;">
    <div class="page-content">
        <h2 class="heading7">{{this.getObjectType==enumObjType.Customer ? ('Language.SalesHeadingText' | translate ):
            this.getObjectType==enumObjType.Vendor ? ('Language.PurchaseHeadingText' | translate) : ('Language.CRMHeadingText' |translate)}}</h2>
        <!-- ============ Customer Detail ============ -->
        <mat-card class="my-4">
            <mat-card-content>
                <h2 class="heading8">
                    {{getFormTitle}}
                </h2>
                <div class="entry-forms">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="row">
                                <div class="col-md-6">
                                    <label class="f-label">{{this.getObjectType==enumObjType.Customer ?('Language.CustomerCodeText'| translate):
                                        this.getObjectType==enumObjType.Vendor ? ('Language.VendorCodeText'| translate) :('Language.LeadCodeText'| translate)}}</label>
                                    <mat-form-field class="full-width" appearance="outline"  >
                                        <input type="text" matInput name="cardCode" [disabled]="this.getFormDisable"
                                            [(ngModel)]="this.getEntryFormDataSource.cardCode"
                                            (ngModelChange)="btnEvent($event)" (click)="onOpenDropDown('connectedvendor',0)">
                                         <img (click)="onOpenDropDown('connectedvendor',0)"
                                         [class.disabled-icon]="getFormDisable"  *ngIf="this.getFormSubTitle!='Lead Details' && this.getFormSubTitle!='Customer Details' && this.getFormSubTitle!='Vendor Details'" src="./assets/images/cfl.svg" matSuffix alt="" class="me-2"> 
                                    </mat-form-field>
                                </div>
                                <div class="col-md-6">
                                    <label class="f-label">{{this.getObjectType==enumObjType.Customer ? ('Language.CustomerNameText'| translate):
                                        this.getObjectType==enumObjType.Vendor ? ('Language.VendorNameText'| translate) : ('Language.LeadNameText'| translate)}}</label>
                                    <mat-form-field class="full-width" appearance="outline">
                                        <input type="text" matInput name="cardName"
                                            [(ngModel)]="this.getEntryFormDataSource.cardName"
                                            (ngModelChange)="btnEvent($event)">
                                    </mat-form-field>
                                </div>
                                <div class="col-md-6">
                                    <label class="f-label"> {{'Language.GroupText' | translate }}</label>
                                    <mat-form-field class="full-width"  appearance="outline">
                                        <input  type="text" matInput name="group"
                                            [(ngModel)]="this.getEntryFormDataSource.groupName" readonly (click)="onOpenDropDown('group',0)">
                                        <img src="./assets/images/cfl.svg" matSuffix alt="" (click)="onOpenDropDown('group',0)" class="me-2">
                                    </mat-form-field>
                                </div>
                                <div class="col-md-6">
                                    <label class="f-label">{{'Language.CurrencyText' | translate }}</label>
                                    <mat-form-field class="full-width" appearance="outline"
                                        >
                                        <input type="text" name="currency"  (click)="onOpenDropDown('currency',0)" 
                                            [(ngModel)]="this.getEntryFormDataSource.currencyName" matInput readonly>
                                        <img src="./assets/images/cfl.svg" matSuffix alt="" class="me-2"  (click)="onOpenDropDown('currency',0)" >
                                    </mat-form-field>
                                </div>
                                <div class="col-md-6">
                                    <label class="f-label"><span class="required">*</span>
                                        {{this.getObjectType==enumObjType.Customer ?('Language.SalesEmployeeText'|translate):
                                        this.getObjectType==enumObjType.Vendor ? ('Language.BuyerText'|translate) : ('Language.SalesEmployeeText'|translate)}}</label>
                                    <mat-form-field class="full-width"   appearance="outline">
                                        <input type="text" matInput name="slpName"
                                           (click)="onOpenDropDown('salesPerson',0)"
                                            [(ngModel)]="this.getEntryFormDataSource.slpName" readonly>
                                        <img src="./assets/images/cfl.svg" matSuffix alt="" class="me-2" (click)="onOpenDropDown('salesPerson',0)">
                                    </mat-form-field>
                                </div>
                                <!-- <div class="col-md-6">
                                    <label class="f-label w-100">{{'Language.BranchAssignmentText' | translate
                                        }}</label>
                                    <br>
                                    <img src="./assets/images/three-dots-menu.svg" matSuffix alt=""
                                        (click)="onOpenDropDown('branch',0)" class="me-2"
                                        style="height: 26px;width: 26px;">
                                </div> -->
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="row">
                                <div class="col-md-6" *ngIf="this.isBpType=='customer'|| this.isBpType=='vendor'">
                                    <label class="f-label">{{'Language.AccountBalanceText' | translate }}</label>
                                    <mat-form-field class="full-width" appearance="outline">
                                        <input type="text" matInput name="accountBalance" disabled
                                            [(ngModel)]="this.getEntryFormDataSource.currentAccountBalance">
                                        <mat-icon matSuffix>remove_red_eye</mat-icon>
                                    </mat-form-field>
                                </div>
                                <div class="col-md-6" *ngIf="this.isBpType=='customer'">
                                    <label class="f-label">{{'Language.OpenDeliveriesText' | translate }}</label>
                                    <mat-form-field class="full-width" appearance="outline">
                                        <input type="text" matInput name="openDeliveries" disabled
                                            [(ngModel)]="this.getEntryFormDataSource.openDeliveryNotesBalance">
                                        <mat-icon matSuffix>remove_red_eye</mat-icon>
                                    </mat-form-field>
                                </div>
                                <div class="col-md-6" *ngIf="this.isBpType=='lead'|| this.isBpType=='customer'">
                                    <label class="f-label">{{'Language.OpenOrderBalanceText' | translate }}</label>
                                    <mat-form-field class="full-width" appearance="outline">
                                        <input type="text" matInput name="openOrderBalance" disabled
                                            [(ngModel)]="this.getEntryFormDataSource.openOrdersBalance">
                                        <mat-icon matSuffix>remove_red_eye</mat-icon>
                                    </mat-form-field>
                                </div>
                                <div class="col-md-6" *ngIf="this.isBpType=='lead'||this.isBpType=='customer'">
                                    <label class="f-label">{{'Language.OpenOpportunityText' | translate }}</label>
                                    <mat-form-field class="full-width" appearance="outline">
                                        <input type="text" matInput name="OpenOpportunity" disabled
                                            [(ngModel)]="this.getEntryFormDataSource.openOpportunities">
                                        <mat-icon matSuffix>remove_red_eye</mat-icon>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>

        <mat-card class="my-4">
            <div class="ip-section">
                <mat-card-content>
                    <mat-tab-group mat-stretch-tabs="false" class="opportunitytabs">
                        <!-- ============ General ============ -->
                        <mat-tab label="General">
                            <div class="entry-forms container-fluid mt-4">
                                <h2 class="heading8">{{'Language.GeneralText' | translate }}</h2>
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="row">
                                            <div class="col-md-12">
                                                <label class="f-label">{{'Language.E-MailText' | translate }}</label>
                                                <mat-form-field class="full-width" appearance="outline">
                                                    <input type="text" matInput name="email"
                                                        [(ngModel)]="this.getEntryFormDataSource.e_Mail"
                                                        (ngModelChange)="btnEvent($event)">
                                                </mat-form-field>
                                            </div>
                                            <!-- <div class="col-md-12">
                                                <label class="f-label">Website</label>
                                                <mat-form-field class="full-width" appearance="outline">
                                                    <input type="text" matInput>
                                                </mat-form-field>
                                            </div>
                                            <div class="col-md-12">
                                                <label class="f-label">Remarks</label>
                                                <mat-form-field class="full-width" appearance="outline">
                                                    <textarea type="text" rows="3" matInput
                                                        placeholder="Write your remarks"></textarea>
                                                    <mat-hint>Maximum characters limit: XXX</mat-hint>
                                                </mat-form-field>
                                            </div> -->
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="row">
                                            <div class="col-md-12">
                                                <label class="f-label">{{'Language.BusinessPartnerTypeText' | translate
                                                    }}</label>
                                                <mat-form-field class="full-width" appearance="outline"
                                                   >
                                                    <input type="text" matInput name="bptype"
                                                        [(ngModel)]="this.getEntryFormDataSource.businessTypeName"
                                                        readonly  (click)="onOpenDropDown('bptype',0)">
                                                    <img src="./assets/images/cfl.svg" matSuffix alt="" class="me-2"  (click)="onOpenDropDown('bptype',0)">
                                                </mat-form-field>
                                            </div>
                                            <!-- <div class="col-md-12">
                                                <label class="f-label">{{'Language.ContactPersonText' | translate
                                                    }}</label>
                                                <mat-form-field class="full-width" appearance="outline">
                                                    <input type="text" matInput name="contactPerson"
                                                        [(ngModel)]="this.getEntryFormDataSource.contactPerson"
                                                        (ngModelChange)="btnEvent($event)">
                                                </mat-form-field>
                                            </div> -->
                                            <div class="col-md-12">
                                                <label class="f-label full-width">{{'Language.StatusText'|translate}}</label>
                                                <mat-radio-group aria-label="Select an option"
                                                    (ngModelChange)="btnEvent($event)" (change)="onChangeRadio($event)">
                                                    <mat-radio-button value="active"
                                                        [checked]="this.getEntryFormDataSource.valid=='Y'">
                                                        {{'Language.ActiveText' | translate }}</mat-radio-button>
                                                    <mat-radio-button value="inactive"
                                                        [checked]="this.getEntryFormDataSource.frozen=='Y'">
                                                        {{'Language.InactiveText' | translate }}</mat-radio-button>
                                                </mat-radio-group>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </mat-tab>
                        <!-- ============ Contact Person ============ -->
                        <mat-tab label="Contact Person">
                            <div class="entry-forms mt-4">
                                <h2 class="heading8">{{'Language.ContactPersonText' | translate }} </h2>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="">
                                            <div class="tabledesign componentstable">
                                                <table mat-table
                                                    [dataSource]="this.getEntryFormDataSource.contactEmployees">
                                                    <ng-container matColumnDef="contactPersonId">
                                                        <th mat-header-cell *matHeaderCellDef class="text-center">
                                                            {{'Language.ContactIdText' | translate }} </th>
                                                        <td mat-cell *matCellDef="let element" class="text-center">
                                                            <div class="pt-1">
                                                                <mat-form-field class="field-bottom-0 mb-1"
                                                                    appearance="outline">
                                                                    <input matInput name="name"
                                                                        [(ngModel)]="element.name"
                                                                        (ngModelChange)="btnEvent($event)" type="text">
                                                                </mat-form-field>
                                                            </div>
                                                        </td>
                                                    </ng-container>
                                                    <ng-container matColumnDef="contactPersonTitle">
                                                        <th mat-header-cell *matHeaderCellDef>
                                                            {{'Language.ContactPersonTitleText' | translate }}</th>
                                                        <td mat-cell *matCellDef="let  element let i=index">
                                                            <div class="pt-1">
                                                                <mat-form-field class="full-width field-bottom-0 mb-1"
                                                                    appearance="outline">
                                                                    <input matInput [(ngModel)]="element.title"
                                                                        name="title"
                                                                        (click)="onEditContactPerson(element,i)">
                                                                </mat-form-field>
                                                            </div>
                                                        </td>
                                                    </ng-container>

                                                    <ng-container matColumnDef="firstName">
                                                        <th mat-header-cell *matHeaderCellDef>{{'Language.FirstNameText'
                                                            | translate }}</th>
                                                        <td mat-cell *matCellDef="let element ; let i=index">
                                                            <div class="pt-1">
                                                                <mat-form-field class="field-bottom-0 mb-1"
                                                                    appearance="outline">
                                                                    <input matInput name="firstName"
                                                                        [(ngModel)]="element.firstName"
                                                                        (ngModelChange)="btnEvent($event)" type="text">
                                                                </mat-form-field>
                                                            </div>
                                                        </td>
                                                    </ng-container>
                                                    <ng-container matColumnDef="lastName">
                                                        <th mat-header-cell *matHeaderCellDef>{{'Language.LastNameText'
                                                            | translate }}</th>
                                                        <td mat-cell *matCellDef="let element ; let i=index">
                                                            <div class="pt-1">
                                                                <mat-form-field class="field-bottom-0 mb-1"
                                                                    appearance="outline">
                                                                    <input matInput name="lastName"
                                                                        [(ngModel)]="element.lastName"
                                                                        (ngModelChange)="btnEvent($event)" type="text">
                                                                </mat-form-field>
                                                            </div>
                                                        </td>
                                                    </ng-container>
                                                    <ng-container matColumnDef="email">
                                                        <th mat-header-cell *matHeaderCellDef>{{'Language.E-MailText' |
                                                            translate }}</th>
                                                        <td mat-cell *matCellDef="let element ; let i=index">
                                                            <div class="pt-1">
                                                                <mat-form-field class="field-bottom-0 mb-1"
                                                                    appearance="outline">
                                                                    <input matInput name="email"
                                                                        [(ngModel)]="element.e_Mail"
                                                                        (ngModelChange)="btnEvent($event)" type="text">
                                                                </mat-form-field>
                                                            </div>
                                                        </td>
                                                    </ng-container>
                                                    <ng-container matColumnDef="telephone1">
                                                        <th mat-header-cell *matHeaderCellDef>
                                                            {{'Language.Telephone1Text' | translate }}</th>
                                                        <td mat-cell *matCellDef="let element ; let i=index">
                                                            <div class="pt-1">
                                                                <mat-form-field class="field-bottom-0 mb-1"
                                                                    appearance="outline">
                                                                    <input matInput name="telephone1"
                                                                        [(ngModel)]="element.phone1"
                                                                        (ngModelChange)="btnEvent($event)" type="text">
                                                                </mat-form-field>
                                                            </div>
                                                        </td>
                                                    </ng-container>
                                                    <ng-container matColumnDef="mobilephone">
                                                        <th mat-header-cell *matHeaderCellDef>
                                                            {{'Language.MobilePhoneText' | translate }}</th>
                                                        <td mat-cell *matCellDef="let element ; let i=index">
                                                            <div class="pt-1">
                                                                <mat-form-field class="field-bottom-0 mb-1"
                                                                    appearance="outline">
                                                                    <input [textMask]="{mask: phoneMaskCharacters}"
                                                                        matInput name="mobilephone"
                                                                        [(ngModel)]="element.mobilePhone"
                                                                        (ngModelChange)="btnEvent($event)" type="text">
                                                                </mat-form-field>
                                                            </div>
                                                        </td>
                                                    </ng-container>
                                                    <ng-container matColumnDef="position">
                                                        <th mat-header-cell *matHeaderCellDef>{{'Language.PositionText'
                                                            | translate }}</th>
                                                        <td mat-cell *matCellDef="let element ; let i=index">
                                                            <div class="pt-1">
                                                                <mat-form-field class="full-width field-bottom-0 mb-1"
                                                                    appearance="outline">
                                                                    <input type="text" matInput name="position"
                                                                        [(ngModel)]="element.position"
                                                                        (ngModelChange)="btnEvent($event)">
                                                                </mat-form-field>
                                                            </div>
                                                        </td>
                                                    </ng-container>
                                                    <!-- <ng-container matColumnDef="department">
                                                        <th mat-header-cell *matHeaderCellDef>Department</th>
                                                        <td mat-cell *matCellDef="
                                                         row">
                                                            <div class="pt-1">
                                                                <mat-form-field class="full-width field-bottom-0 mb-1"
                                                                    appearance="outline">
                                                                    <mat-select>
                                                                        <mat-option></mat-option>
                                                                    </mat-select>
                                                                </mat-form-field>
                                                            </div>
                                                        </td>
                                                    </ng-container> -->
                                                    <ng-container matColumnDef="active">
                                                        <th mat-header-cell *matHeaderCellDef>{{'Language.ActiveText' |
                                                            translate}} </th>
                                                        <td mat-cell *matCellDef="let element;let i=index;">
                                                            <div class="pt-1">
                                                                <mat-checkbox class="me-3"
                                                                    (change)="onChangeContactActiveCheckBox($event,i);" name="isActive"
                                                                
                                                                    [checked]="element.active=='Y'">
                                                                </mat-checkbox>
                                                                <!--    [(ngModel)]="element.isActive"  -->
                                                            </div>
                                                        </td>
                                                    </ng-container>

                                                    <ng-container matColumnDef="del">
                                                        <th mat-header-cell *matHeaderCellDef class="text-center">
                                                            {{'Language.DeleteText' | translate}} </th>
                                                        <td mat-cell *matCellDef="let element;let i=index">
                                                            <div class="d-flex justify-content-center">
                                                                <i-feather class="t-icon pointer" name="trash-2"
                                                                    (click)="deleteContactPersonRow(i)"></i-feather>

                                                            </div>
                                                        </td>
                                                    </ng-container>
                                                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                                    <tr mat-row *matRowDef="let row; columns: displayedColumns;">
                                                    </tr>
                                                </table>
                                            </div>
                                        </div>
                                        <div class="col-md-12 mt-3">
                                            <button #buttonAddContact mat-raised-button color="primary"
                                                (click)="onAddNewContactPerson($event)">
                                                {{'Language.AddNewContactPersonText' | translate }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </mat-tab>
                        <!-- ============ Address ============ -->
                        <mat-tab label="Address">
                            <div class="entry-forms cusAddress mt-4">
                                <div class="row">
                                    <div class="col-md-6 mb-3 mb-sm-0">
                                        <h2 class="heading9"> {{'Language.BillToText' | translate }} </h2>
                                        <div *ngFor="let row of this.getEntryFormDataSource.bpAddresses let i = index">
                                            <div class="card3" *ngIf="row.addressType=='bo_BillTo'">
                                                <div class="d-flex">
                                                    <h2 class="heading9 flex-grow-1 mb-1"> {{row.addressName}}</h2>
                                                    <i-feather class="t-icon pointer me-3" name="trash-2"
                                                        (click)="deleteAddressRow(i)"></i-feather>
                                                    <i-feather class="t-icon pointer" name="edit-2"
                                                        (click)="openAddressDialog('bo_BillTo',i,'edit')"></i-feather>
                                                </div>
                                                <p class="fs-6 inter"> {{getAddress(row)}}</p>
                                                <!-- <mat-checkbox class="ca-checkbox">Make this as Default Address
                                                </mat-checkbox> -->


                                                <!-- (change)="onChangeSetAsDefaultCheckBox($event)" -->
                                                <!-- <div>
                                                    <mat-checkbox value="this.getEntryFormDataSource.billtoDefault"
                                                        [checked]="row.billtoDefault=='Bill To'" name="isAsDefault"
                                                        [(ngModel)]="row.billtoDefault"
                                                        (ngModelChange)="btnEvent($event)">
                                                        {{'Language.SetAsDefaultText' | translate }}
                                                    </mat-checkbox>
                                                </div> -->
                                            </div>


                                        </div>
                                        <div class="col-md-12 mt-3">
                                            <button #buttonAddContact mat-raised-button color="primary"
                                                (click)="openAddressDialog('bo_BillTo')">
                                                {{'Language.AddNewBillingAddressText' | translate }}
                                            </button>
                                        </div>
                                    </div>
                                    <div class="col-md-6 ">
                                        <h2 class="heading9"> Shipping Address </h2>
                                        <div *ngFor="let row of this.getEntryFormDataSource.bpAddresses; let i = index">
                                            <div class="card3" *ngIf="row.addressType=='bo_ShipTo'">

                                                <div class="d-flex">
                                                    <h2 class="heading9 flex-grow-1 mb-1"> {{row.addressName}} </h2>
                                                    <i-feather class="t-icon pointer me-3" name="trash-2"
                                                        (click)="deleteAddressRow(i)"></i-feather>
                                                    <i-feather class="t-icon pointer" name="edit-2"
                                                        (click)="openAddressDialog('bo_ShipTo',i,'edit')"></i-feather>
                                                </div>
                                                <p class="fs-6 inter">{{getAddress(row)}}</p>
                                                <!-- <mat-checkbox class="ca-checkbox">Make this as Default Address
                                                </mat-checkbox> -->


                                                <!-- (change)="onChangeSetAsDefaultCheckBox($event)" -->

                                                <div mat-cell *matCellDef="let row;">
                                                    <mat-checkbox value="this.getEntryFormDataSource.shiptoDefault"
                                                        [checked]="row.shiptoDefault=='Ship To'" name="isAsDefault"
                                                        [(ngModel)]="row.shiptoDefault"
                                                        (ngModelChange)="btnEvent($event)">
                                                        {{'Language.SetAsDefaultText' | translate }}
                                                    </mat-checkbox>
                                                </div>
                                            </div>


                                        </div>
                                        <div class="col-md-12 mt-3">
                                            <button #buttonAddContact mat-raised-button color="primary"
                                                (click)="openAddressDialog('bo_ShipTo')">
                                                {{'Language.AddNewShippingAddressText' | translate }}
                                            </button>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </mat-tab>
                        <!-- ============ Payment Terms ============ -->
                        <mat-tab label="Payment Terms">
                            <div class="entry-forms mt-4">
                                <h2 class="heading8">{{'Language.PaymentTermsText'|translate}}</h2>
                                <div class="row">
                                    <div class="col-md-3">
                                        <label class="f-label">{{'Language.PaymentTermsText' | translate }}</label>
                                        <mat-form-field class="full-width" appearance="outline"
                                            >
                                            <input type="text" matInput name="paymentterms" readonly (click)="onOpenDropDown('paymentterms',0)"
                                                [(ngModel)]="this.getEntryFormDataSource.payTermsGrpCodeName">
                                            <img src="./assets/images/cfl.svg" matSuffix alt="" class="me-2" (click)="onOpenDropDown('paymentterms',0)">
                                        </mat-form-field>
                                    </div>
                                    <!-- <div class="col-md-3">
                                        <label class="f-label">{{'Language.GSTTypeText' | translate }}</label>
                                        <mat-form-field class="full-width" appearance="outline">
                                          <input type="text" matInput readonly [(ngModel)]="this.getEntryFormDataSource.bpAddresses[0].gstType"
                                            (click)="onOpenDropDown('gsttype')">
                                          <img src="./assets/images/cfl.svg" matSuffix alt="" class="me-2">
                                        </mat-form-field>
                                      </div> -->
                                    <div class="col-md-3">
                                        <label class="f-label">{{'Language.PriceListText' | translate }}</label>
                                        <mat-form-field class="full-width" appearance="outline"
                                            >
                                            <input type="text" matInput name="pricelist" readonly (click)="onOpenDropDown('pricelist',0)"
                                                [(ngModel)]="this.getEntryFormDataSource.priceListName">
                                            <img src="./assets/images/cfl.svg" matSuffix alt="" class="me-2" (click)="onOpenDropDown('pricelist',0)">
                                        </mat-form-field>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="tabledesign partnertable">
                                            <table mat-table [dataSource]="this.getEntryFormDataSource.bpBankAccounts">
                                                <ng-container matColumnDef="bankName">
                                                    <th mat-header-cell *matHeaderCellDef>Bank Name</th>
                                                    <td mat-cell *matCellDef="let element ; let i=index">
                                                        <div class="pt-1">
                                                            <mat-form-field class="field-bottom-0 mb-1"
                                                                appearance="outline"
                                                               >
                                                                <input matInput type="text" name="bankName" readonly
                                                                    [(ngModel)]="element.bankName"  (click)="onOpenDropDown('banks',i)">
                                                                <img src="./assets/images/cfl.svg" matSuffix alt=""  (click)="onOpenDropDown('banks',i)"
                                                                    class="me-2">
                                                            </mat-form-field>

                                                        </div>
                                                    </td>
                                                </ng-container>
                                                <ng-container matColumnDef="accountName">
                                                    <th mat-header-cell *matHeaderCellDef>
                                                        {{'Language.BankAccountNameText' | translate }}</th>
                                                    <td mat-cell *matCellDef="let element ; let i=index">
                                                        <div class="pt-1">
                                                            <mat-form-field class="field-bottom-0 mb-1"
                                                                appearance="outline"
                                                                >
                                                                <input matInput type="text" name="accountName"
                                                                    [(ngModel)]="element.accountName" disabled>
                                                                   
                                                            </mat-form-field>
                                                        </div>
                                                    </td>
                                                </ng-container>
                                                <ng-container matColumnDef="countryName">
                                                    <th mat-header-cell *matHeaderCellDef>
                                                        {{'Language.CountryText' | translate }}</th>
                                                    <td mat-cell *matCellDef="let element ; let i=index">
                                                        <div class="pt-1">
                                                            <mat-form-field class="field-bottom-0 mb-1"
                                                                appearance="outline">
                                                                <input matInput type="text" name="countryName"
                                                                    [(ngModel)]="element.countryName" readonly>
                                                            </mat-form-field>
                                                        </div>
                                                    </td>
                                                </ng-container>

                                                <ng-container matColumnDef="accountNo">
                                                    <th mat-header-cell *matHeaderCellDef>{{'Language.AccountNumberHeadingText'|translate}}</th>
                                                    <td mat-cell *matCellDef="let element ; let i=index">
                                                        <div class="pt-1">
                                                            <mat-form-field class="field-bottom-0 mb-1"
                                                                appearance="outline"  >
                                                                <input matInput type="text" name="accountNo"
                                                                    [(ngModel)]="element.accountNo" 
                                                                  (click)="onOpenDropDown('accounts',i)" >
                                                                    <img src="./assets/images/cfl.svg" (click)="onOpenDropDown('accounts',i)" matSuffix alt=""
                                                                    class="me-2">
                                                            </mat-form-field>
                                                        </div>
                                                    </td>
                                                </ng-container>
                                                <ng-container matColumnDef="bicSwiftCode">
                                                    <th mat-header-cell *matHeaderCellDef>{{'Language.IFSCCodeText'|translate}}</th>
                                                    <td mat-cell *matCellDef="let element ; let i=index">
                                                        <div class="pt-1">
                                                            <mat-form-field class="field-bottom-0 mb-1"
                                                                appearance="outline">
                                                                <input matInput type="text" name="bicSwiftCode"
                                                                    [(ngModel)]="element.bicSwiftCode">
                                                            </mat-form-field>
                                                        </div>
                                                    </td>
                                                </ng-container>
                                                <ng-container matColumnDef="delete">
                                                    <th mat-header-cell *matHeaderCellDef class="text-center">
                                                        {{'Language.DeleteText' | translate}}
                                                    </th>
                                                    <td mat-cell *matCellDef="let element;let i=index">
                                                        <div class="d-flex  justify-content-center">
                                                            <i-feather class="t-icon pointer me-2" name="trash-2"
                                                                (click)="onDeleteNewBank(i)">

                                                            </i-feather>
                                                            <!-- <mat-icon class="pointer text-primary">add_box</mat-icon> -->
                                                        </div>
                                                    </td>
                                                </ng-container>
                                                <tr mat-header-row *matHeaderRowDef="this.displayedColumnPaymentTerms">
                                                </tr>
                                                <tr mat-row
                                                    *matRowDef="let row; columns: this.displayedColumnPaymentTerms;">
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                    <div class="col-md-12 mt-3">
                                        <button #buttonAddContact mat-raised-button color="primary"
                                            (click)="onAddNewBank()">
                                            {{'Language.AddNewBankText' | translate }}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </mat-tab>
                        <!-- ============ Accounting ============ -->
                        <mat-tab label="Accounting">
                            <div class="entry-forms mt-4">
                                <h2 class="heading8">{{'Language.AccountingText'|translate}}</h2>
                                <div class="row">
                                    <div class="col-md-6">
                                        <label class="f-label">{{getObjectType==enumObjType.Customer ?('Language.ConnectedCustomerText'| translate):('Language.ConnectedVendorText'|translate)}} </label>
                                        <mat-form-field class="full-width" appearance="outline"
                                           >
                                            <input type="text" matInput name="connectedvendor"   (click)="onOpenDropDown('connectedvendor',0)"
                                                [(ngModel)]="this.getEntryFormDataSource.linkedBusinessPartnerName">
                                            <img src="./assets/images/cfl.svg" matSuffix alt="" class="me-2"  (click)="onOpenDropDown('connectedvendor',0)">
                                        </mat-form-field>
                                    </div>
                                    <div class="col-md-6"></div>
                                    <div class="col-md-6 mb-3">
                                        <label class="f-label mb-0"> {{'Language.SubjecttoWithholdingTaxText' |
                                            translate }}</label>
                                        <div class="">
                                            <mat-checkbox value="this.getEntryFormDataSource.subjectToWithholdingTax"
                                                [checked]="this.getEntryFormDataSource.subjectToWithholdingTax=='Y'"
                                                (change)="onChangeSubjectToWithholdingTax($event)"
                                                (ngModelChange)="btnEvent($event)">
                                                {{'Language.SubjecttoWithholdingTaxText' | translate }}
                                            </mat-checkbox>
                                        </div>
                                    </div>
                                    <div class="col-md-6 mb-3">
                                        <label class="f-label mb-0"> </label>
                                        <div class="">
                                            <mat-radio-group [(ngModel)]="this.getEntryFormDataSource.accrualCriteria"
                                                name="radioButtons" (change)="onChangeAccontingRadio($event)"
                                                (ngModelChange)="btnEvent($event)">
                                                <mat-radio-button id="accrual" value="Y">{{'Language.AccrualText' |
                                                    translate }}
                                                </mat-radio-button>
                                                <mat-radio-button id="cash" value="N">{{'Language.CashText' | translate
                                                    }}
                                                </mat-radio-button>
                                            </mat-radio-group>
                                        </div>
                                    </div>
                                    <div class="col-md-6"
                                        *ngIf="this.getEntryFormDataSource.subjectToWithholdingTax=='Y'">
                                        <label class="f-label">{{'Language.AsseseeTypeText' | translate }}</label>
                                        <mat-form-field class="full-width" appearance="outline"
                                            >
                                            <input type="text" matInput name="assesseetype" readonly (click)="onOpenDropDown('assesseetype',0)"
                                                [(ngModel)]="this.getEntryFormDataSource.typeReportName">
                                            <img src="./assets/images/cfl.svg" matSuffix alt="" class="me-2" (click)="onOpenDropDown('assesseetype',0)">
                                        </mat-form-field>
                                    </div>
                                    <!-- <div class="col-md-6"
                                        *ngIf="this.getEntryFormDataSource.subjectToWithholdingTax=='Y'">
                                        <label class="f-label">{{'Language.WTaxCodeAllowedText' | translate }}</label>
                                        <mat-form-field class="full-width" appearance="outline"
                                            (click)="onOpenDropDown('wtaxcode',0)">
                                            <input type="text" matInput name="watxcodeallowed" readonly
                                                [(ngModel)]="this.getEntryFormDataSource.wtCodeName">
                                            <img src="./assets/images/cfl.svg" matSuffix alt="" class="me-2">
                                        </mat-form-field>
                                    </div> -->

                                    <div class="col-md-6"
                                        *ngIf="this.getEntryFormDataSource.subjectToWithholdingTax=='Y'">
                                        <!-- &&this.getEntryFormDataSource.bpFiscalTaxIDCollection!=null && this.getEntryFormDataSource.bpFiscalTaxIDCollection.length>0 -->
                                        <label class="f-label">{{'Language.PANNo.Text' | translate }}</label>
                                        <mat-form-field class="full-width" appearance="outline">
                                            <input type="text" matInput name="panno"
                                                [(ngModel)]="this.getEntryFormDataSource.bpFiscalTaxIDCollection[0].taxId0"
                                                (ngModelChange)="btnEvent($event)">
                                        </mat-form-field>
                                    </div>



                                </div>
                            </div>
                        </mat-tab>
                    </mat-tab-group>
                </mat-card-content>
            </div>
        </mat-card>
    



    <mat-card class="my-4">
        <mat-card-content>
            <h2 class="heading8">{{'Language.AttachmentsText' | translate }}</h2>
            <div class="">
                <div class="entry-forms w-55">
                    <div class="col-md-12 mt-3">
                        <label class="f-label full-width">{{'Language.AttachmentsText' | translate
                          }}</label>
                        <!-- <button mat-raised-button class="uploadbtn" color="primary" (click)="onUpload()">
                          <i-feather class="t-icon" name="upload"> </i-feather>
                          {{'Language.UploadFilesText' | translate }}
                        </button> -->
                        <!-- <input type="file" class="file-upload" (change)="onSelectedFiles($event)" multiple> -->
                        <button mat-raised-button class="uploadbtn" color="primary" (click)="input.click()">
                            <i-feather class="t-icon" name="upload"> </i-feather>
                            {{'Language.ChooseFilesText' | translate }}
                        </button>
                        <input type="file" class="file-upload d-none" #input (change)="onSelectedFiles($event)" multiple>
                        <span class="field-hint d-block">{{'Language.Youcanuploadamaximumof10files,5MBeachText'
                          | translate }}</span>
                    </div>
                    <div class="col-md-12 mt-4">
                       <div class="carddesign">
                            <table class="table table-striped" *ngIf="this.getEntryFormDataSource.Attachments2_Lines 
                            && this.getEntryFormDataSource.Attachments2_Lines.length > 0">   
                                <thead>
                                    <tr>
                                        <th scope="col">{{'Language.ThumbnailText' | translate}}</th>
                                        <th scope="col" width="25%">{{'Language.FileNameText' | translate}}</th>
                                        <th scope="col">{{'Language.FileTypeText' | translate}}</th>
                                        <th scope="col">View</th>
                                        <th scope="col">{{'Language.DeleteText' | translate}}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let item of this.getEntryFormDataSource.Attachments2_Lines;let i = index">
                                        <th scope="row"><i-feather class="" name="image"></i-feather></th>
                                        <td>{{item.FileName}}</td>
                                        <td>{{item.FileExtension}}</td>
                                        <td>
                                            <mat-icon class="pointer"
                                                [ngClass]="{'disabled': !item.AbsoluteEntry}"
                                                (click)="viewImage(item.AbsoluteEntry)">
                                                remove_red_eye
                                            </mat-icon>
                                        </td>
                                        <td>
                                            <i-feather 
                                            class="t-icon pointer" 
                                            name="trash-2" 
                                            (click)="onAttachmentDelete(i)">
                                            </i-feather>
                                        </td>
                                    </tr>
                                </tbody> 
                            </table>
                        </div>
                    </div>

                    <div class="col-md-12 mt-3">
                        <ng-container *ngIf="this.selectedFile.length > 0">
                            <div class="text-end">
                                <button mat-raised-button class="uploadbtn" color="primary" (click)="onUpload()">
                                    <i-feather class="t-icon" name="upload"> </i-feather>
                                    {{'Language.UploadFilesText' | translate }}
                                </button>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
        </mat-card-content>
    </mat-card>
</div>
</fieldset>
<div class="mt-2 footer">
    <div class="d-flex">
        <div class="me-auto">
            <button *ngIf="(getFormMode == 0 && canAdd) || (getFormMode == 1 && canEdit)" mat-raised-button class="me-1" color="primary" (click)="onSave($event)">
                {{ btnText | translate}}
            </button>
            <button mat-stroked-button color="primary"
                (click)="onClickOfGenericCancelButton($event)">{{'Language.CancelText' | translate}}</button>
        </div>

    </div>
</div>
</div>